import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { SewWidgetWrapper, } from './packages/sew-widget';
import { config, } from './packages/sew-core/config';
import PageHead from './components/PageHead';
import Global from './components/Global';
import theme from './config/theme';
import './index.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render((
  <>
    <PageHead />
    <Global />
    <SewWidgetWrapper initialData={{ theme, config, }} />
  </>
), document.getElementById('root',),);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
